var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDividerAbout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 124,
    viewBox: "0 0 1280 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M905.731 58C1063.42 15 1198.66 66.5 1280 124H0V12.5C69.8635 3.33333 239.033 -9.5 356.803 12.5C504.016 40 748.039 101 905.731 58Z",
    fill: "#C996CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M506.24 54.4999C363.968 113.5 143.77 4.40927 0 30.4093V124H1279V38.5C1194.14 83.1667 1011.23 153.4 958.515 77C892.621 -18.5 648.512 -4.50008 506.24 54.4999Z",
    fill: "#1C0C5B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDividerAbout);
export default __webpack_public_path__ + "static/media/divider_about.7736ff80f6359e81511e1d4744ebb4b4.svg";
export { ForwardRef as ReactComponent };